import { cn } from '../UI/cn'
import ReactCreatableSelect from 'react-select/creatable'
import React, { forwardRef } from 'react'
import { useModalDepth } from '../UI/Modal/ModalPrimitive'
import { getDropdownZIndex } from '../../styles/z-index'

export const ReactCreatableSelectWrapper = forwardRef<any, any>(
  (props, ref) => {
    const modalDepth = useModalDepth()
    const zIndex = React.useMemo(
      () => getDropdownZIndex(modalDepth),
      [modalDepth]
    )

    return (
      <ReactCreatableSelect
        menuPortalTarget={document.body}
        closeMenuOnScroll={false}
        blurInputOnSelect={false}
        captureMenuScroll={false}
        menuShouldBlockScroll={false}
        {...props}
        styles={{
          ...props.styles,
          menuPortal: (provided) => ({
            ...provided,
            zIndex,
            pointerEvents: 'all',
          }),
          control: (provided, state) => ({
            // ...provided,
            ...props.styles?.control?.(provided, state),
            display: 'flex',
            minHeight: props?.height || '33.5px',
            // Override focus colors to prevent blue highlight
            borderColor: state.isFocused ? '#8EA69B' : '#DEE2E6',
            boxShadow: state.isFocused
              ? '2px 2px 4px 0px rgba(142, 166, 155, 0.20)'
              : 'none',
            '&:hover': {
              borderColor: state.isFocused ? '#8EA69B' : '#DEE2E6',
            },
          }),
          placeholder: (provided, state) => ({
            ...provided,
            ...props.styles?.placeholder?.(provided, state),
            color: undefined,
          }),
          multiValue: (provided, state) => ({
            ...provided,
            ...props.styles?.multiValue?.(provided, state),
            borderRadius: '6px',
          }),
          multiValueRemove: (provided, state) => ({
            ...provided,
            ...props.styles?.multiValueRemove?.(provided, state),
            borderRadius: '0px 6px 6px 0px',
          }),
        }}
        classNames={{
          ...props.classNames,
          control: (provided) => {
            return cn(
              'form-control-select',
              {
                'form-control-select-focus': provided.isFocused,
                'opacity-50': props.isDisabled,
              },
              props.classNames?.control?.(provided) ?? ''
            )
          },
          placeholder: (provided) =>
            'form-control-select-placeholder' +
            (props.classNames?.placeholder?.(provided) ?? ''),
          option: (provided) =>
            `${provided.isFocused ? 'hover-menu-item' : ''} ${
              provided.isSelected ? 'selected-menu-item' : ''
            }` + (props.classNames?.option?.(provided) ?? ''),
        }}
        ref={ref}
      />
    )
  }
)

ReactCreatableSelectWrapper.displayName = 'ReactCreatableSelectWrapper'
